import {
  CopilotAnswerResponse,
  type CreateImprovedCopilotAnswerDTO,
} from './types';
import { laravelAxios } from 'src/config/axios/laravelAxios';
import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

export type UserLanguage = 'pt-br' | 'en-us' | 'es';

export class CopilotAnswerService {
  static async createCopilotAnswer(
    messages: any[],
    contact_uuid: string,
    user_uuid: string,
    channel_id: number,
    user_language: UserLanguage
  ): Promise<any> {
    const url = `/ia/messages/suggest_answer`;

    const data = {
      contactUuid: contact_uuid,
      userUuid: user_uuid,
      messages: messages, // enviar as ultimas 20 mensagens
      channelId: channel_id,
      language: user_language || 'pt-br',
    };

    const response = await poliApiGatewayRequest.post<CopilotAnswerResponse>(
      url,
      data
    );

    return response.data;
  }

  static async updateContactCopilot(
    suggest_answer: boolean,
    contact_uuid: string
  ): Promise<any> {
    const url = `/suggest-answer/${contact_uuid}`;

    const data = {
      suggest_answer,
    };

    const response = await laravelAxios.post(url, data);

    return response.data;
  }

  static async getContactCopilot(contact_uuid: string): Promise<any> {
    const url = `/suggest-answer/${contact_uuid}`;

    const response = await laravelAxios.get<any>(url);

    return response.data;
  }

  static async createImprovedCopilotAnswer(
    data: CreateImprovedCopilotAnswerDTO
  ): Promise<any> {
    const url = `/copilot/ai/improve-message`;

    const response = await poliApiGatewayRequest.post<any>(url, data);

    return response.data;
  }
}
